import { Route, Routes } from "react-router-dom";
import FormulaBuilder from "./formula-builder";
const Main = () => {
  return (
    <Routes>
      <Route index path="/formulaEditor" element={<FormulaBuilder />} />
      <Route index path="/formulaEditor/:id" element={<FormulaBuilder />} />
    </Routes>
  );
};
export default Main;
